//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import {PublicAppLayout} from 'app_components/layouts/public'
import AllNewsModule from 'app_components/modules/newsEvents/allnews'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../allnewsScreen.scss'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'

// @ADD Component types
interface IAllnewsScreenLayoutProps {}

const AllnewsScreenLayout: React.FC<IAllnewsScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <PublicAppLayout>
      <div className='all-news-screen--layout'>
        <TextComponent type='title' as='h2' textTransform='none'>Noticias</TextComponent>
        <AllNewsModule/>
      </div>
    </PublicAppLayout>
  )
}

export default AllnewsScreenLayout
